var _path, _g, _ellipse, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33374 24.1861C4.7288 23.0443 5.81262 22.2773 7.03109 22.2773H28.4377C29.6402 22.2773 30.7135 23.0246 31.1207 24.1454L35.507 36.2187C36.1757 38.0592 34.7988 39.9996 32.824 39.9996H2.85366C0.897286 39.9996 -0.478 38.0926 0.156309 36.2593L4.33374 24.1861Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_21_531)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.066 18.256L19.4337 32.9258C20.1475 34.2625 20.6591 35.337 21.3729 34.0002L31.1545 18.2689C32.1504 16.5726 32.7207 14.601 32.7207 12.4974C32.7207 6.14772 27.5242 1.00028 21.1141 1.00028C14.7039 1.00028 9.5074 6.14771 9.5074 12.4974C9.5074 14.2728 9.91363 15.9541 10.639 17.4553L10.6449 17.4673C10.7752 17.7362 10.9157 17.9992 11.066 18.256Z",
    fill: "url(#paint0_linear_21_531)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.066 18.256L19.4337 32.9258C20.1475 34.2625 20.6591 35.337 21.3729 34.0002L31.1545 18.2689C32.1504 16.5726 32.7207 14.601 32.7207 12.4974C32.7207 6.14772 27.5242 1.00028 21.1141 1.00028C14.7039 1.00028 9.5074 6.14771 9.5074 12.4974C9.5074 14.2728 9.91363 15.9541 10.639 17.4553L10.6449 17.4673C10.7752 17.7362 10.9157 17.9992 11.066 18.256Z",
    stroke: "url(#paint1_linear_21_531)",
    strokeWidth: 0.5
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.1142,
    cy: 12.5409,
    rx: 4.3525,
    ry: 4.31143,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_21_531",
    x: 6.35781,
    y: -2.15,
    width: 29.5129,
    height: 39.9133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21_531"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21_531",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_531",
    x1: 30.2366,
    y1: 31.7984,
    x2: 2.00642,
    y2: 21.7974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#393184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_531",
    x1: 19.1796,
    y1: 29.274,
    x2: 3.37109,
    y2: 4.03656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7AFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon3);
export default __webpack_public_path__ + "static/media/location-icon3.8d4cebc2cb7bb556e0b6729bb3220117.svg";
export { ForwardRef as ReactComponent };